// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__kToj5","file":"styles_file__2gLu7"};